import React, { FC, ReactElement } from 'react';

import css from './style.module.scss';

interface IProps {
  children: ReactElement;
}

const LoaderWrap: FC<IProps> = ({ children }) => <div className={css.loaderWrap}>{children}</div>;

export default LoaderWrap;
